const question3 = {
    'question': 'Jak przebiega interwencja kryzysowa? Ile ma etapów?',
    'answer': 'Interwencja kryzysowa to krótkoterminowa forma pomocy psychologicznej, która ma na celu przywrócenie równowagi psychicznej osobom przeżywającym kryzys. Przebieg interwencji kryzysowej można podzielić na kilka etapów: zdefiniowanie problemu, zapewnienie bezpieczeństwa, zapewnienie wsparcia, rozważenie możliwości, ułożenie planu',
}

export default question3;